export default __webpack_public_path__ + "images/video-calling-step-1.a973a5b6299c5a9e7af445018cc2a234.png";